@if (dashboard.open()) {
    <div class="dl-dashboardv2__paneel">
        <div class="dl-dashboardv2__kop">
            <h3>{{ 'DASHBOARD.TITEL' | translate }}
                <button type="button" class="btn-close btn-close-white" aria-label="Close"
                        (click)="sluitPaneel()"></button>
            </h3>
        </div>
        <div class="dl-dashboardv2__body">
            <div class="dl-dashboardv2__controls">
                <div class="mb-3">
                    <label class="form-label fw-bold">{{ 'DASHBOARDV2.MOMENT_START' | translate }}</label>
                    <div class="input-group">
                        <sihwdatumveld class="form-control dl-dashboardv2__datum"
                                       [size]="10" autoJaarStrikt
                                       [title]="'DASHBOARDV2.TITLES.MOMENT_START' | translate"
                                       [ngModel]="form().startdate"
                                       (ngModelChange)="zetForm({startdate: $event})"></sihwdatumveld>
                        <input type="time" #starttijd class="form-control dl-dashboardv2__tijd"
                               [title]="'DASHBOARDV2.TITLES.MOMENT_START' | translate"
                               [value]="form().starttime ?? ''"
                               (change)="zetForm({starttime: starttijd.value})">
                    </div>
                </div>
                <div class="mb-3">
                    <label class="form-label fw-bold">{{ 'DASHBOARDV2.MOMENT_END' | translate }}</label>
                    <div class="input-group">
                        <sihwdatumveld class="form-control dl-dashboardv2__datum"
                                       [size]="10" autoJaarStrikt
                                       [title]="'DASHBOARDV2.TITLES.MOMENT_END' | translate"
                                       [ngModel]="form().enddate"
                                       (ngModelChange)="zetForm({enddate: $event})"></sihwdatumveld>
                        <input type="time" #eindtijd class="form-control dl-dashboardv2__tijd"
                               [title]="'DASHBOARDV2.TITLES.MOMENT_END' | translate"
                               [value]="form().endtime ?? ''"
                               (change)="zetForm({endtime: eindtijd.value})">
                    </div>
                </div>
                <div class="dl-dashboardv2__nolabel">
                    <button type="button" class="btn btn-primary"
                            [title]="'DASHBOARDV2.TITLES.BIJWERKEN' | translate"
                            (click)="bijwerken()">{{ 'DASHBOARDV2.BIJWERKEN' | translate }}
                    </button>
                </div>
                <div class="dl-dashboardv2__ruimte"></div>
                <div class="dl-dashboardv2__nolabel">
                    <button type="button" class="btn btn-primary"
                            [title]="'DASHBOARDV2.TITLES.RESETALLES' | translate"
                            (click)="resetAlles()">{{ 'DASHBOARDV2.RESETALLES' | translate }}
                    </button>
                </div>
                <div class="dl-dashboardv2__nolabel">
                    <button type="button" class="btn btn-primary"
                            [title]="'DASHBOARDV2.TITLES.RESETNU' | translate"
                            (click)="resetNu()">{{ 'DASHBOARDV2.RESETNU' | translate }}
                    </button>
                </div>
                <div class="dl-dashboardv2__ruimte"></div>
                <div class="dl-dashboardv2__nolabel">
                    <button type="button" role="switch" class="dl-dashboardv2__switch"
                            [attr.aria-checked]="form().live"
                            [title]="'DASHBOARDV2.TITLES.SWITCH_LIVE' | translate"
                            (click)="toggleLive()">
                        <span class="dl-dashboardv2__switchbar"
                              [class.dl-dashboardv2__switchbar--aan]="form().live">
                            <span class="dl-dashboardv2__switchdrop"></span>
                        </span>
                        <span>{{ 'DASHBOARD.LIVE' | translate }}</span>
                    </button>
                </div>
                <div class="dl-dashboardv2__ruimte"></div>
                <div class="mb-3">
                    <label class="form-label fw-bold" for="dl-dashboardv2-filter">{{ 'DASHBOARDV2.FILTER' | translate }}</label>
                    <div class="input-group dl-dashboardv2__filter">
                        <input type="text" id="dl-dashboardv2-filter" #filterveld class="form-control"
                               [title]="'DASHBOARDV2.TITLES.FILTER' | translate"
                               [value]="form().filter"
                               (input)="planFilter(filterveld.value)">
                        <button class="btn btn-secondary" type="button" (click)="wisFilter(filterveld)">
                            <i class="fa-solid fa-eraser" aria-hidden="true"
                               [title]="'DASHBOARDV2.TITLES.FILTER_ERASE' | translate"></i>
                        </button>
                    </div>
                </div>
                <div class="mb-3">
                    <label class="form-label fw-bold" for="dl-dashboardv2-grid">{{ 'DASHBOARDV2.GRID' | translate }}</label>
                    <select class="form-select" id="dl-dashboardv2-grid" #gridkeuze
                            [title]="'DASHBOARDV2.TITLES.GRID' | translate"
                            [value]="gridKeuze()"
                            (change)="zetGrid(gridkeuze.value)">
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                    </select>
                </div>
                <div class="mb-3">
                    <div>
                        <label class="form-label fw-bold">{{ 'DASHBOARDV2.SORTEER.LABEL' | translate }}</label>
                    </div>
                    <div class="btn-group">
                        <button type="button" class="btn btn-primary" [class.active]="form().sorteer === 'az'"
                                [title]="'DASHBOARDV2.SORTEER.ALFABET_TITLE' | translate"
                                (click)="zetSortering('az')">{{ 'DASHBOARDV2.SORTEER.ALFABET' | translate }}
                        </button>
                        <button type="button" class="btn btn-primary" [class.active]="form().sorteer === 'aantal'"
                                [title]="'DASHBOARDV2.SORTEER.AANTAL_TITLE' | translate"
                                (click)="zetSortering('aantal')">{{ 'DASHBOARDV2.SORTEER.AANTAL' | translate }}
                        </button>
                        <button type="button" class="btn btn-primary" [class.active]="form().sorteer === 'fout'"
                                [title]="'DASHBOARDV2.SORTEER.FOUT_TITLE' | translate"
                                (click)="zetSortering('fout')">{{ 'DASHBOARDV2.SORTEER.FOUT' | translate }}
                        </button>
                        <button type="button" class="btn btn-primary" [class.active]="form().sorteer === 'begin'"
                                [title]="'DASHBOARDV2.SORTEER.BEGIN_TITLE' | translate"
                                (click)="zetSortering('begin')"><i class="dl-fa4 dl-fa4--pijl-op"></i>
                        </button>
                        <button type="button" class="btn btn-primary" [class.active]="form().sorteer === 'eind'"
                                [title]="'DASHBOARDV2.SORTEER.EIND_TITLE' | translate"
                                (click)="zetSortering('eind')"><i class="dl-fa4 dl-fa4--pijl-neer"></i>
                        </button>
                    </div>
                </div>
                @if (dashboard.bezig()) {
                    <div class="dl-dashboardv2__nolabel dl-dashboardv2__laden">
                        <i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i>
                    </div>
                }
            </div>
            <hr>
            <div class="dl-dashboardv2__raster" [style.grid-template-columns]="'repeat(' + form().grid + ', 1fr)'">
                @for (rij of rijen(); track rij.model.id) {
                    <div class="dl-dashboardv2__blok">
                        <dl-modelactie [model]="rij.model" [data]="rij.data" [periode]="periode()" [nu]="nu()"
                                       (click)="meekijken(rij.model)"></dl-modelactie>
                    </div>
                }
            </div>
        </div>
    </div>
}
